module.exports = __webpack_public_path__ + "img/student_9.5700d242.png";